import { render, staticRenderFns } from "./TemoignagesSlider.vue?vue&type=template&id=2e33b392&scoped=true&"
import script from "./TemoignagesSlider.vue?vue&type=script&lang=js&"
export * from "./TemoignagesSlider.vue?vue&type=script&lang=js&"
import style0 from "./TemoignagesSlider.vue?vue&type=style&index=0&id=2e33b392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33b392",
  null
  
)

export default component.exports